import F from 'offline/filter/constants'
// Port of api/fuel/app/classes/filter/package/games/collection/prepare/renames.php
export default {
	run: function(local, global) {
		if (global.ownerType !== F.OWNER_USER) return local
		local.collection = local.collection || {}
		local.collection.rename = (global.crenames && global.crenames[local.id]) ? global.crenames[local.id] : false
		return local
	}
}
